module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_7042.e4d39545.png";